import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";
import { isEmpty } from 'lodash';
import moment from 'moment'
import {
  Paper, Table, IconButton, Container, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, CircularProgress, Drawer, Button, Chip,
} from '@mui/material';
import { FilterList } from '@mui/icons-material'
import ArrowBack from '@mui/icons-material/ArrowBack';
import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import ModalFilter from './EmailLogsSuperadminModalFilter/index';
import LogModal from './EmailLogDetailsModal/index'

export default function TableEmailLogsSuperadmin(props) {
  const dispatch = useDispatch();
  let textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySearched, setAlreadySearched] = useState(false);
  const [limit, setLimit] = useState(25);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [order, setOrder] = useState("asc");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [filteredStartDate, setFilteredStartDate] = useState(null)
  const [filteredEndDate, setFilteredEndDate] = useState(null)
  const [filteredEmailTypes, setFilteredEmailTypes] = useState([])
  const [filteredTenants, setFilteredTenants] = useState([])

  const emailLogsFilter = useSelector(state => state.emailLogs.emailLogsFilter);

  const loading = useSelector(state => state.emailLogs.loading);

  const isSuperadmin = useSelector(state => state.auth.superadmin);
  if (!isSuperadmin) props.history.push('/');

  const fetchEmailLogs = useCallback(() => dispatch(actions.fetchEmailLogs(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredEmailTypes, filteredTenants)),
    [page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredEmailTypes, filteredTenants]
  );

  const emailLogs = useSelector(state => state.emailLogs.emailLogs);

  const headRows = [
    { id: "createdAt", numeric: false, disablePadding: false, label: "Data de criação" },
    { id: "type", numeric: false, disablePadding: false, label: "Tipo" },
    { id: "recipients", numeric: false, disablePadding: false, label: "Endereço de email" },
    { id: "tenant", numeric: false, disablePadding: false, label: "Tenant" },
  ];

  const populateFilters = () => {
    setFilteredStartDate(emailLogsFilter.startDate);
    setFilteredEndDate(emailLogsFilter.endDate);
    setFilteredEmailTypes(emailLogsFilter.filteredEmailTypes);
    setFilteredTenants(emailLogsFilter.filteredTenants);
  }

  useEffect(() => {
    // dispatch(actions.showSearchNavbarText(false));
    setPage(emailLogsFilter.page);
    setLimit(emailLogsFilter.limit);
    setSearchText(emailLogsFilter.search);
    setOrderBy(emailLogsFilter.orderBy);
    setOrder(emailLogsFilter.order);
  }, []);

  useEffect(() => {
    if (!isEmpty(emailLogsFilter) && !isFilterOpen) populateFilters();
  }, [emailLogsFilter])

  useEffect(() => {
    fetchEmailLogs();
    setAlreadySearched(true);
  }, [page, limit, order, orderBy]);

  useEffect(() => {
    if (searchText !== "" || alreadySearched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchEmailLogs();
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  const selectRow = (e, id) => {
    dispatch(actions.fetchEmailLogsById(id));
    setIsLogModalOpen(true);
  }

  const deleteFilteredStartDate = () => {
    dispatch(actions.triggerRemoveEmailLogsStartDateFilter(page, limit, searchText, order, orderBy, filteredEndDate, filteredEmailTypes, filteredTenants))
  }

  const deleteFilteredEndDate = () => {
    dispatch(actions.triggerRemoveEmailLogsEndDateFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEmailTypes, filteredTenants))
  }

  const deleteFilteredEmailTypes = (emailType) => {
    dispatch(actions.triggerRemoveEmailLogsEmailTypesFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredEmailTypes, filteredTenants, emailType))
  }

  const deleteFilteredTenants = (tenant) => {
    dispatch(actions.triggerRemoveEmailLogsTenantsFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredEmailTypes, filteredTenants, tenant))
  }

  const renderStartDateChip = () => (filteredStartDate && <Chip
    label={`Data de criação De: ${moment(filteredStartDate).format('DD/MM/YYYY - HH:mm:ss')}`}
    onDelete={() => deleteFilteredStartDate()}
    style={styles.filterChip} />)
  const renderEndDateChip = () => (filteredEndDate && <Chip
    label={`Vencimento Até: ${moment(filteredEndDate).format('DD/MM/YYYY - HH:mm:ss')}`}
    onDelete={() => deleteFilteredEndDate()}
    style={styles.filterChip} />)
  const renderEmailTypesChip = () => (filteredEmailTypes && filteredEmailTypes.map((type) => (<Chip
    key={type.value}
    label={type.label}
    onDelete={() => deleteFilteredEmailTypes(type)}
    style={styles.filterChip} />)))
  const renderTenantsChip = () => (filteredTenants && filteredTenants.map((tenant, index) => (<Chip
    key={index}
    label={tenant.label}
    onDelete={() => deleteFilteredTenants(tenant)}
    style={styles.filterChip} />)))

  const clearFilterButton = () => {
    if ((filteredStartDate)
      || (filteredEndDate)
      || (filteredEmailTypes && filteredEmailTypes.length > 0)
      || (filteredTenants && filteredTenants.length > 0))
      return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>Limpar</Typography>;
  };

  const handleClickClearFilters = () => {
    dispatch(actions.clearEmailLogsFilter(page, limit, searchText, order, orderBy));
  };

  return <>
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}>
      <ModalFilter
        closeModal={() => setIsFilterOpen(false)}
        path={props.match.path}
      />
    </Drawer>
    <Drawer
      BackdropProps={{ invisible: true }}
      variant="temporary"
      anchor="right"
      onClose={() => setIsLogModalOpen(false)}
      open={isLogModalOpen}>
      <LogModal
        closeModal={() => setIsLogModalOpen(false)}
      />
    </Drawer>
    <Container style={{ ...styles.container }}>
      <IconButton
        style={styles.actionButton}
        aria-label="back"
        onClick={() => props.history.goBack()}
        size="large">
        <ArrowBack />
      </IconButton>
      <Paper>
        <TableTitle
          title='Logs de e-mail'
          placeholder='Pesquisar'
          inputRef={textInput}
          value={searchText}
          onChange={event => {
            setPage(1);
            setSearchText(event.target.value);
          }}
        />
        <div style={styles.filterChipContainer}>
          <Button
            variant='contained'
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
            filtros <FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderStartDateChip()}
          {renderEndDateChip()}
          {renderEmailTypesChip()}
          {renderTenantsChip()}
          {clearFilterButton()}
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <div style={styles.spinner}>
                    <CircularProgress />
                  </div>}
                {emailLogs.rows.length === 0 &&
                  <div style={styles.noResults}>
                    {!loading && <Typography style={styles.spinner}>Nenhum resultado encontrado</Typography>}
                  </div>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={{ opacity: loading ? '0.3' : '1' }}
            headRows={headRows}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody style={{ opacity: loading ? '0.3' : '1' }}>
            {emailLogs.rows.map((log, index) => {
              return (
                <TableRow
                  style={styles.tableRow}
                  key={log._id}
                  hover
                  onClick={event => selectRow(event, log._id)}
                >
                  <TableCell style={styles.cell}>
                    <div style={styles.statusContainer}>
                      {<span style={styles.label}>{moment(log.createdAt).format('DD/MM/YYYY - HH:mm:ss')}</span>}
                    </div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                                              {log.emailType}
                                      </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log.recipients}</div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log?.tenant?.name ? log.tenant.name : '...'}</div>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
          <TableFooter style={{ opacity: loading ? '0.3' : '1' }}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[25, 50]}
                count={emailLogs.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </Container>
  </>;

}

const styles = {
  container: {
    padding: 0
  },
  table: {
    position: 'relative',
    marginBottom: '4rem',
  },
  tableRow: {
    cursor: 'pointer'
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
  noResults: {
    height: '100px',
  },
  deleteTextConfirm: {
    marginLeft: '-30px',
    fontWeight: 'bold',
  },
  editWidth: {
    width: '90%'
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  avatar: {
    width: '2.75rem',
    height: '2.75rem',
  },
  avatarSmallText: {
    fontSize: '0.775rem',
    width: '2.75rem',
    height: '2.75rem',
  },
  chip: {
    margin: 5,
  },
  thumbUp: {
    marginRight: 15,
    color: "#349c34"
  },
  thumbDown: {
    marginRight: 15,
    color: "#d04545"
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
  },
  cell: {
    fontSize: '0.775rem',
    padding: '0.25rem',
  },
  cellChip: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  label: {
    marginLeft: '0.5rem'
  },
   buttonFilterIcon: {
    marginLeft: 5
  },
  buttonFilter: {
    zIndex: 200,
    backgroundColor: '#008100',
    height: '2.2rem',
    width: '6.5rem',
    padding: '1rem',
    color: '#fff',
  },
  clearFilter: {
    cursor: 'pointer',
    textDecoration: 'underline',
    zIndex: 200,
    padding: '0.75rem 0.5rem',
    color: '#000',
  },
  filterContainer: {
    position: 'relative',
    width: '100%',
  },
  filterChipContainer: {
    paddingLeft: 20,
    display: 'flex',
    flexWrap: 'wrap',
  },
  filterChip: {
    cursor: 'pointer',
    margin: 5,
  },
  actionButton: {
    marginBottom: 5,
  }
}
